// @ts-nocheck
import React from "react";
import Deals from "./Deals";
import CustomerLeads from "./CustomerLead";

const Users = React.lazy(() => import("./Users"));
const EmailNewsletters = React.lazy(() => import("./EmailNewsletters"));
const Coupons = React.lazy(() => import("./Coupons"));
const CompanyAgents = React.lazy(() => import("./CompanyAgents"));
const Agents = React.lazy(() => import("./Agents"));
const Orders = React.lazy(() => import("./Orders"));
const TouchCreateOrder = React.lazy(() => import("./Orders/TouchCreateOrder"));
const TouchEditOrder = React.lazy(() => import("./Orders/TouchCreateOrder/TouchEditOrder"));
const Quotes = React.lazy(() => import("./Quotes"));
const Expenses = React.lazy(() => import("./Expenses"));
const ExpenseTypes = React.lazy(() => import("./ExpenseTypes"));
const Leads = React.lazy(() => import("./Leads"));
const Campaigns = React.lazy(() => import("./Campaigns"));
const Tasks = React.lazy(() => import("./Tasks"));

export const crmConfig = [
  {
    path: "/crm/users",
    element: <Users />,
  },
  {
    path: "/crm/email-newsletters",
    element: <EmailNewsletters />,
  },
  {
    path: "/crm/coupons",
    element: <Coupons />,
  },
  {
    path: "/crm/tasks",
    element: <Tasks />,
  },
  {
    path: "/crm/company-agents",
    element: <CompanyAgents />,
  },
  {
    path: "/crm/agents",
    element: <Agents />,
  },
  {
    path: "/crm/orders",
    element: <Orders />,
  },
  {
    path: "/crm/orders/touch-create",
    element: <TouchCreateOrder />,
  },
  {
    path: "/crm/orders/touch-edit/:orderId",
    element: <TouchEditOrder />,
  },
  {
    path: "/crm/quotes",
    element: <Quotes />,
  },
  {
    path: "/crm/expenses",
    element: <Expenses />,
  },
  {
    path: "/crm/expense-types",
    element: <ExpenseTypes />,
  },
  {
    path: "crm/leads",
    element: <Leads />,
  },
  {
    path: "crm/customer-leads",
    element: <CustomerLeads />,
  },
  {
    path: "/crm/deals",
    element: <Deals />,
  },
  {
    path: "/crm/campaigns",
    element: <Campaigns />,
  },
];
